import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import StyledTableRow from './styledTableRow';
import StyledTableCell from './styledTableCell';

const wrapTextStyle = {
    display: 'inline-block',
    // overflow: 'hidden',
    // textOverflow: 'ellipsis',
    //maxWidth: '20ch',
};

const StyledTable1 = (props) => {
    return (
        <>
            {/* <Box sx={{ width: '100%', mb: 2 }} > */}
            {/* <EnhancedTableToolbar
                    handleClick={props.addClick}
                    title={props.title}
                    buttonTitle={props.buttonTitle}
                /> */}
            <Paper sx={{ width: '100%' }}>
                <TableContainer component={Paper}>
                    <Table aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                {props.rowHeader.map((item, index) => {
                                    return (
                                        <StyledTableCell
                                            //maxWidth={item.width}
                                            key={`title_${index}`}>
                                            {item.title}
                                        </StyledTableCell>
                                    );
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.data ? (
                                props.data.length > 0 ? (
                                    props.data.map(({ row }, index) => (
                                        <StyledTableRow
                                            key={`${props.keyPrefix}_${index}`}>
                                            {props.rowHeader.map(
                                                (header, i) => {
                                                    return (
                                                        <StyledTableCell
                                                            key={i}
                                                            size="small"
                                                            component="th"
                                                            sx={{
                                                                backgroundColor:
                                                                    row[i][
                                                                        'highlight'
                                                                    ]
                                                                        ? 'yellow'
                                                                        : '',
                                                            }}
                                                            //maxWidth={row[i].width}
                                                            scope="row">
                                                            <span
                                                                style={
                                                                    wrapTextStyle
                                                                }>
                                                                {
                                                                    row[i][
                                                                    header
                                                                        .key
                                                                    ]
                                                                }
                                                            </span>
                                                        </StyledTableCell>
                                                    );
                                                }
                                            )}
                                        </StyledTableRow>
                                    ))
                                ) : (
                                    <StyledTableRow>
                                        <StyledTableCell
                                            colSpan={props.rowHeader.length}
                                            align="center">
                                            No data found
                                        </StyledTableCell>
                                    </StyledTableRow>
                                )
                            ) : (
                                <StyledTableRow>
                                    <StyledTableCell
                                        colSpan={props.rowHeader.length}
                                        align="center">
                                        Loading.....
                                    </StyledTableCell>
                                </StyledTableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
            {/* </Box> */}
        </>
    );
};
export default StyledTable1;
